var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.666,
    height: 23.667,
    viewBox: "0 0 23.666 23.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout_FILL0_wght300_GRAD0_opsz24",
    d: "M142.518-796.332a2.429,2.429,0,0,1-1.786-.731,2.429,2.429,0,0,1-.731-1.786v-18.633a2.429,2.429,0,0,1,.731-1.786,2.429,2.429,0,0,1,1.786-.731h9.33v2.088h-9.33a.41.41,0,0,0-.295.134.41.41,0,0,0-.134.295v18.633a.41.41,0,0,0,.134.295.409.409,0,0,0,.295.134h9.33v2.088Zm15.207-5.89-1.446-1.51,3.389-3.389H147.792v-2.088h11.876l-3.389-3.389,1.446-1.51,5.943,5.943Z",
    transform: "translate(-140.002 819.999)",
    fill: "#ef7b13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.dfd880cf59bd73e557113791438faf6d.svg";
export { ForwardRef as ReactComponent };